<div class="modal-header">
    <h2 class="modal-title">Yuki sync instellingen</h2>
    <button
        (click)="activeModal.dismiss()"
        aria-label="Close"
        class="close"
        type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <div (click)="updateNightlySyncEnabled()" class="d-flex align-items-center">
        <span [ngClass]="{'toggle--active': nightlySyncEnabled}" class="toggle"></span>
        <label class="m-l-4">Automatische nachtelijke Yuki-sync</label>
    </div>

    <p class="form-helptext m-t-2">Wanneer ingeschakeld, draait de Yuki-sync elke nacht automatisch om 04:00. Manuele synchronisaties via deze pagina blijven steeds beschikbaar.</p>

    <hr/>

    <div (click)="updateRunAiOnSync()" class="d-flex align-items-center">
        <span [ngClass]="{'toggle--active': runAiOnSync}" class="toggle"></span>
        <label class="m-l-4">AI auto-allocatie automatisch uitvoeren tijdens sync</label>
    </div>

    <p class="form-helptext m-t-2">Wanneer ingeschakeld, draait de AI automatisch na het synchroniseren van Yuki documenten.</p>

    <p class="form-helptext m-t-4"><i class="uil uil-info-circle"></i> Wanneer er na een nachtelijke sync nieuwe AI-allocaties zijn, krijgen de mailadressen die voor <strong>YUKI_NEW_INVOICES_REMINDER</strong> in de <strong>Mailing setup</strong> staan een mail met per item een <em>Accept</em> / <em>Decline</em> knop. Decline herstart de AI-allocatie tijdens de volgende nacht.</p>

    <p class="form-helptext m-t-2"><i class="uil uil-info-circle"></i> Het AI-model kan je instellen bij de <strong>OpenAI integratie</strong> in de module-instellingen.</p>

</div>

<div class="modal-footer">
    <button
        (click)="activeModal.dismiss()"
        class="button button--outline"
        type="button">
        Sluiten
    </button>
</div>
